import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUser = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 13.574,
	height: 13.817,
	viewBox: "0 0 13.574 13.817",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		id: "Group_1254",
		"data-name": "Group 1254",
		transform: "translate(-475.545 -3443)",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Group_968",
			"data-name": "Group 968",
			transform: "translate(474.75 3443)",
			children: [/* @__PURE__ */ _jsxs("g", {
				id: "Ellipse_9",
				"data-name": "Ellipse 9",
				transform: "translate(2.864)",
				fill: "none",
				stroke: "#000",
				strokeWidth: 1,
				children: [/* @__PURE__ */ _jsx("ellipse", {
					cx: 4.455,
					cy: 4.204,
					rx: 4.455,
					ry: 4.204,
					stroke: "none"
				}), /* @__PURE__ */ _jsx("ellipse", {
					cx: 4.455,
					cy: 4.204,
					rx: 3.955,
					ry: 3.704,
					fill: "none"
				})]
			}), /* @__PURE__ */ _jsx("g", {
				id: "Path_703",
				"data-name": "Path 703",
				transform: "translate(-2.035 7.236)",
				fill: "#fff",
				style: { fill: "black" },
				children: /* @__PURE__ */ _jsx("path", {
					d: "M 9.4296875 1.143186569213867 C 6.971707344055176 1.143186569213867 5.316367149353027 1.510226249694824 4.509677886962891 2.234126567840576 C 3.945647239685059 2.740256309509277 3.830077171325684 3.430096387863159 3.830077171325684 4.310176372528076 C 3.830077171325684 4.730576515197754 3.922247886657715 4.85348653793335 3.952537536621094 4.893876552581787 C 4.068877220153809 5.049006462097168 4.352717399597168 5.158946514129639 4.570347785949707 5.223856449127197 C 5.562597274780273 5.519806385040283 7.444827079772949 5.580446243286133 9.965697288513184 5.580446243286133 C 12.46002769470215 5.580446243286133 14.16609764099121 5.523486137390137 14.96324729919434 5.23996639251709 C 15.24625778198242 5.139296531677246 15.29367733001709 5.050766468048096 15.30926704406738 5.021676540374756 C 15.37232780456543 4.903946399688721 15.40429782867432 4.664566516876221 15.40429782867432 4.310176372528076 C 15.40429782867432 3.349376440048218 15.15625762939453 2.738126516342163 14.57490730285645 2.266306400299072 C 13.65664768218994 1.521056175231934 11.92554759979248 1.143186569213867 9.4296875 1.143186569213867 M 9.4296875 0.1431865692138672 C 15.53124809265137 0.1431865692138672 16.404296875 2.345296382904053 16.404296875 4.310176372528076 C 16.404296875 6.2750563621521 15.60131740570068 6.580446243286133 9.965697288513184 6.580446243286133 C 4.330077171325684 6.580446243286133 2.830078125 6.2750563621521 2.830078125 4.310176372528076 C 2.830078125 2.345296382904053 3.328127861022949 0.1431865692138672 9.4296875 0.1431865692138672 Z",
					stroke: "none",
					style: { strokeWidth: "0.8px" }
				})
			})]
		})
	})]
});
const ForwardRef = forwardRef(SvgUser);
export { ForwardRef as ReactComponent };
